module.exports = __webpack_public_path__ + "static/media/daily.a5adbb0b.gif";